// extracted by mini-css-extract-plugin
export var smallSpinner = "_wo-0";